import styled from 'styled-components'
import Flex from '../../../../components/Flex'
import { COLORS } from 'theme'
import InputNumber from 'components/Form/InputNumber'
import { Spin } from 'antd'
export const Spinner = styled(Spin)`
  padding-top: 30%;
  position: absolute;
`
export const Wrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 50%;
  padding-top: 2%;
  margin-left: 4%;
  padding: 27px 5px 100px 5px;
  max-height: 500px;
  row-gap: 20px;
`
export const Container = styled(Flex)`
  backgroundcolor: #d6dbf7;
`

export const SectionWrapper = styled(Flex)`
  width: 100%;
  // border: 1px solid ${COLORS.PAGE_BORDER};
  // box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  border-radius: 10px;
  height: 85vh;
  overflow: hidden;

  background: #fafafb;
  &::-webkit-scrollbar {
    display: '';
  }
`

export const MainWrapper = styled(Flex)`
  width: 100%;
  gap: 10px;
  height: 70vh;
  overflow-y: scroll;
  //  max-height: 100%;
  background: #fafafb;
  margin-top: -21px;
  // &::-webkit-scrollbar {
  //   width: 8px; /* Width of the entire scrollbar */
  // }

  // &::-webkit-scrollbar-track {
  //   background: #f1f1f1; /* Background of the scrollbar track */
  // }

  // &::-webkit-scrollbar-thumb {
  //   background-color: #888; /* Color of the scrollbar thumb */
  //   border-radius: 10px; /* Roundness of the scrollbar thumb */
  //   border: 2px solid #f1f1f1; /* Space around the thumb */
  // }

  // &::-webkit-scrollbar-thumb:hover {
  //   background: #555; /* Color of the scrollbar thumb on hover */
  // }
`
export const TierInputNumber = styled(InputNumber)`
  .ant-input-number-handler-wrap {
    display: none !important;
    width: 100%;
  }
  .ant-input-number-suffix {
    display: none;
  }
`

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
    min-width: 10vw;
  }
`
export const SelectWrapper = styled.div`
  width: 50%;
`
export const RichWrapper = styled.div`
  padding-top: 10px;
`

export const LabelDiv = styled.div`
  width: 100%;
  position: relative;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.01em;
  color: rgb(112, 112, 112) !important;
  padding-bottom: 8px;
  // padding-top: 10px;
`
export const InputWrapper = styled.div`
  position: relative;
`

export const StyledInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`

export const DeleteButton = styled.button`
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
`
export const Dummy = styled.div`
  font-size: 17px;
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  text-align: center;
  color: red;
`

export const TypeGroup = styled(Flex)`
  gap: 12px;
  display: flex;
  flex-wrap: wrap;
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
  margin-top: -19px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
`
export const NoDataFound = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-size: small;
  font-weight: 600;
  border: 1px solid rgb(220, 236, 250);
  margin: 0em 0.5em;
  border-radius: 5px;
  padding: 11.5em 0em;
`
export const ButtonDirection = styled(Flex)`
  flex-direction: column-reverse;
  padding-left: 25px;
`
